import { ToastContainer as ReactToastContainer } from 'react-toastify';

/**
 * Single app-wide toast container. Mount once in App.jsx.
 * Use from any component: import { toast } from 'utils/toast'; toast.success('Done');
 */
export default function ToastContainer() {
  return (
    <ReactToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
    />
  );
}
